import { computed } from 'vue'
import { createMultipleListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'
import { useMeta } from '@/composables/useMeta'

export const useImportProducts = createSharedComposable(() => {
    const { meta } = useMeta()

    const list = computed(() => {
        return meta.products?.map(product => ({
            label: product.name,
            value: product.id
        }))
    })

    return createMultipleListQuery('import-products', list, {
        normalize: value => value?.map(Number).filter(Boolean),
        defaultValue: undefined
    })
})
